/**
 * Created by charnjeetelectrovese@gmail.com on 5/1/2020.
 */
import {serviceGetAppSettings, serviceUpdateGeoFence,serviceUpdatePolicies, serviceGetThemeByDomain} from "../services/AppSettings.service";
import EventEmitter from "../libs/Events.utils";

export const APP_SETTINGS_INIT = 'APP_SETTINGS_INIT';
export const APP_SETTINGS_DONE = 'APP_SETTINGS_DONE';
export const APP_SETTINGS_UPDATE_GEOFENCE = 'APP_SETTINGS_UPDATE_GEOFENCE';
export const APP_SETTINGS_CHANGE_THEME = 'APP_SETTINGS_CHANGE_THEME';
export const APP_SETTINGS_UPDATE_POLICIES = 'APP_SETTINGS_UPDATE_POLICIES';
export const APP_SETTINGS_SET_DOMAIN_THEME = 'APP_SETTINGS_SET_DOMAIN_THEME';

export function actionGetAppSettings(data) {
    const req = serviceGetAppSettings({});
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_INIT, payload: {} });
        req.then((data) => {
            if (!data.error) {
                const tempData = data.data;
                dispatch({ type: APP_SETTINGS_DONE, payload: tempData });
            }
        });
    };
    // return ({type: AUTH_USER, payload: data});
}


export function actionUpdateGeoFence(data) {
    const request = serviceUpdateGeoFence({ polygon: data } )
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_UPDATE_GEOFENCE, payload: data })
    }
}

export function actionChangeTheme(theme) {
    return (dispatch) => {
        localStorage.setItem('theme', theme);
        dispatch({type: APP_SETTINGS_CHANGE_THEME, payload: theme});
    }
}

export function actionUpdatePolicies(name, value) {
    const request = serviceUpdatePolicies({ name, value } ).then((res) => {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved Successfully', type: 'success'});
    });
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_UPDATE_POLICIES, payload: {name, value} })
    }
}

export function actionGetThemeByDomain() {
    return async (dispatch) => {
        try {
            const updateUITheme = (themeData) => {
                dispatch({ type: APP_SETTINGS_SET_DOMAIN_THEME, payload: themeData });
                
                if (themeData && themeData.theme) {
                    if (themeData.theme.fav_icon) {
                        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                        link.type = 'image/x-icon';
                        link.rel = 'shortcut icon';
                        link.href = themeData.theme.fav_icon;
                        document.getElementsByTagName('head')[0].appendChild(link);
                    }
                    if (themeData.name) {
                        document.title = themeData.name;
                    }
                }
            };

            const cachedTheme = localStorage.getItem('domainTheme');
            if (cachedTheme) {
                try {
                    const parsedTheme = JSON.parse(cachedTheme);
                    updateUITheme(parsedTheme);
                } catch (e) {
                    console.error("Error parsing cached theme", e);
                }
            }

            const res = await serviceGetThemeByDomain();
            if (res.data && res.data.response_code === 1) {
                const themeData = res.data.response_obj.theme;
                localStorage.setItem('domainTheme', JSON.stringify(themeData));
                updateUITheme(themeData);
            }
        } catch (error) {
            console.error("Error fetching theme:", error);
        }
    };
}
